const localStorageKey = 'clientStoredHash'
const responseHeaderKey = 'gitCommitHash'
const authMeResponseKey = 'gitCommitHash'

export { authMeResponseKey, localStorageKey, responseHeaderKey }
